// extracted by mini-css-extract-plugin
export default {"modalContent":"styles_modalContent__XEKEg","modalTitle":"styles_modalTitle__QnQ4x","modalList":"styles_modalList__ECWeX","clientItem":"styles_clientItem__jRuse"};